<section
  class="dashboard-aside-widget dashboard-aside-widget--store-config"
  aria-labelledby="dashboard-store-config-status-title">
  <h4 id="dashboard-store-config-status-title" class="dashboard-aside-widget__title">
    {{ 'dashboard.store_config_status.title' | translate }}
  </h4>

  <div class="dashboard-aside-widget__split">
    <div class="dashboard-aside-widget__metric">
      <strong class="dashboard-aside-widget__metric-value">{{ totalStores() }}</strong>
      <span class="dashboard-aside-widget__metric-label">
        {{ 'dashboard.store_config_status.storesLabel' | translate }}
      </span>
    </div>

    <div
      class="dashboard-aside-widget__status"
      [class.dashboard-aside-widget__status--success]="statusVariant() === 'success'"
      [class.dashboard-aside-widget__status--partial]="statusVariant() === 'partial'"
      [class.dashboard-aside-widget__status--incomplete]="statusVariant() === 'incomplete'">
      @if (statusVariant() === 'success') {
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      <span>{{ 'dashboard.store_config_status.allComplete' | translate }}</span>
      } @else if (statusVariant() === 'partial') {
      <mat-icon aria-hidden="true">info</mat-icon>
      <span>
        {{
          'dashboard.store_config_status.partialComplete'
            | translate:{ complete: completeCount(), total: totalStores() }
        }}
      </span>
      } @else {
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <span>{{ 'dashboard.store_config_status.noneComplete' | translate }}</span>
      }
    </div>
  </div>

  <button
    type="button"
    mat-stroked-button
    color="primary"
    class="dashboard-lost-claim-card__action"
    (click)="navigateToStores()">
    {{ 'dashboard.store_config_status.goToStores' | translate }}
  </button>
</section>
